(() => {
  if (window.PSCart) return;
  const root = document.getElementById('ps-cart-root');
  if (!root || !window.HTMLDialogElement) return;
  const drawer = root.querySelector('#ps-cart-dialog');
  const preview = root.querySelector('#ps-preview-dialog');
  const strings = root.querySelector('[data-ps-strings]').dataset;
  const nativeFetch = window.fetch.bind(window);
  const base = root.dataset.root;
  const cartPath = new URL(root.dataset.cartUrl, location.origin).pathname.replace(/\/$/, '');
  let discountCodes = [];
  let busy = false, sequence = 0, refreshTimer, oldOverflow, opener;
  const status = text => { root.querySelector('[data-ps-status]').textContent = text; };
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-ps-change], [data-ps-discount] button, [data-ps-remove-code], .ps-checkout').forEach(el => { el.disabled = value; });
  }
  function safeURL(value, sameOrigin = false) {
    try {
      const u = new URL(value, location.origin);
      return /^https?:$/.test(u.protocol) && (!sameOrigin || u.origin === location.origin) ? u.href : '';
    } catch { return ''; }
  }
  function sanitiseLinks() {
    root.querySelectorAll('[data-ps-edit]').forEach(a => {
      const url = safeURL(a.getAttribute('href'), true);
      if (url) a.href = url; else a.remove();
    });
  }
  function updateShipping() {
    const date = new Date();
    date.setDate(date.getDate() + 3);
    root.querySelectorAll('[data-ps-ship-date]').forEach(el => {
      el.textContent = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    });
  }
  function renderCodes() {
    const container = root.querySelector('[data-ps-codes]');
    if (!container) return;
    container.replaceChildren();
    discountCodes.filter(c => c.applicable).forEach(c => {
      const chip = document.createElement('span');
      chip.className = 'ps-code-chip';
      const label = document.createElement('span');
      label.textContent = c.code;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.psRemoveCode = c.code;
      button.setAttribute('aria-label', strings.removeCode + ' ' + c.code);
      button.textContent = '×';
      chip.append(label, button);
      container.append(chip);
    });
  }
  async function refresh() {
    const ticket = ++sequence;
    const url = new URL(location.href);
    url.searchParams.set('section_id', 'ps-cart-drawer');
    url.searchParams.set('_ps', String(Date.now()));
    const [r, cartResponse] = await Promise.all([
      nativeFetch(url, { credentials: 'same-origin', cache: 'no-store' }),
      nativeFetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
    ]);
    if (!r.ok || !cartResponse.ok) throw new Error(strings.error);
    const parsed = new DOMParser().parseFromString(await r.text(), 'text/html');
    const content = parsed.querySelector('[data-ps-content]');
    const state = content?.querySelector('[data-ps-state]');
    if (!content || !state) throw new Error(strings.error);
    const cartData = await cartResponse.json();
    const footer = parsed.querySelector('.ps-footer');
    if (!footer) throw new Error(strings.error);
    if (ticket !== sequence) return;
    discountCodes = Array.isArray(cartData.discount_codes) ? cartData.discount_codes : [];
    const active = document.activeElement;
    const focusedKey = active?.closest('[data-key]')?.dataset.key;
    const wasQuantity = active?.hasAttribute('data-ps-change');
    const expanded = root.querySelector('.ps-discount-toggle')?.open;
    const draft = root.querySelector('[name=discount]')?.value || '';
    root.querySelector('[data-ps-content]').replaceChildren(...content.childNodes);
    root.querySelector('.ps-footer').replaceChildren(...footer.childNodes);
    const disclosure = root.querySelector('.ps-discount-toggle');
    if (disclosure) disclosure.open = !!expanded;
    const input = root.querySelector('[name=discount]');
    if (input) input.value = draft;
    updateShipping();
    renderCodes();
    setBusy(busy);
    root.querySelector('[data-ps-count]').textContent = state.dataset.count;
    root.querySelector('[data-ps-total]').textContent = state.dataset.total;
    root.querySelector('.ps-footer').hidden = Number(state.dataset.count) === 0;
    document.querySelectorAll('[data-ps-cart-count]').forEach(el => { el.textContent = state.dataset.count; });
    sanitiseLinks();
    if (wasQuantity) {
      const line = [...root.querySelectorAll('[data-key]')].find(el => el.dataset.key === focusedKey);
      const target = line?.querySelector('[data-ps-change]') || root.querySelector('[data-ps-close]');
      requestAnimationFrame(() => target.focus());
    }
  }
  async function open() {
    if (!drawer.open) {
      opener = document.activeElement;
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.showModal();
      root.querySelector('[data-ps-close]').focus();
    }
    status(strings.loading);
    try { await refresh(); status(''); } catch { status(strings.error); }
  }
  function close() { drawer.close(); }
  drawer.addEventListener('close', () => {
    if (preview.open) preview.close();
    document.body.style.overflow = oldOverflow || '';
    opener?.focus?.();
  });
  function backdrop(event, dialog) {
    if (event.target !== dialog) return;
    const b = dialog.getBoundingClientRect();
    if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
  }
  drawer.addEventListener('click', e => backdrop(e, drawer));
  preview.addEventListener('click', e => backdrop(e, preview));
  preview.querySelector('img').addEventListener('error', () => {
    preview.querySelector('[data-ps-image-status]').textContent = strings.imageError;
  });
  async function write(endpoint, payload) {
    if (busy) return null;
    setBusy(true); status(strings.loading); ++sequence;
    try {
      const r = await nativeFetch(base + 'cart/' + endpoint + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await r.json();
      if (!r.ok) throw new Error(typeof data.description === 'string' ? data.description : strings.error);
      await refresh(); status(''); return data;
    } catch (error) {
      try { await refresh(); } catch {}
      status(error.message || strings.error); return null;
    } finally { setBusy(false); }
  }
  root.addEventListener('click', async e => {
    const button = e.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-ps-close')) close();
    if (button.hasAttribute('data-ps-preview-close')) preview.close();
    if (button.hasAttribute('data-ps-preview')) {
      const url = safeURL(button.dataset.psPreview);
      if (!url) return;
      preview.querySelector('[data-ps-image-status]').textContent = '';
      preview.querySelector('img').src = url;
      if (!preview.open) preview.showModal();
    }
    if (button.hasAttribute('data-ps-change')) {
      const item = button.closest('[data-key]');
      await write('change', { id: item.dataset.key, quantity: Number(button.dataset.psChange) });
    }
    if (button.hasAttribute('data-ps-remove-code')) {
      const code = button.dataset.psRemoveCode.toLowerCase();
      const remaining = discountCodes.filter(c => c.code.toLowerCase() !== code).map(c => c.code);
      const data = await write('update', { discount: remaining.join(',') });
      if (data) root.querySelector('.ps-discount-toggle > summary')?.focus();
    }
  });
  root.addEventListener('submit', async e => {
    if (!e.target.matches('[data-ps-discount]')) {
      if (busy) e.preventDefault();
      return;
    }
    e.preventDefault();
    if (busy) return;
    const code = new FormData(e.target).get('discount').trim();
    if (!code) return;
    const existing = discountCodes.filter(c => c.applicable && c.code.toLowerCase() !== code.toLowerCase()).map(c => c.code);
    const data = await write('update', { discount: [...existing, code].join(',') });
    if (!data) return;
    const codes = data.discount_codes;
    if (Array.isArray(codes)) {
      const match = codes.find(c => c.code.toLowerCase() === code.toLowerCase());
      status(match?.applicable ? strings.applied : strings.invalid);
      if (match?.applicable) {
        const input = root.querySelector('[name=discount]');
        if (input) input.value = '';
        const disclosure = root.querySelector('.ps-discount-toggle');
        if (disclosure) { disclosure.open = false; disclosure.querySelector('summary').focus(); }
      }
    } else status(strings.checkCode);
  });
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const target = e.target.closest('a, button');
    if (!target || root.contains(target)) return;
    let isCart = target.hasAttribute('data-ps-cart-open');
    if (target.matches('a[href]')) {
      try {
        const u = new URL(target.href, location.href);
        isCart ||= u.origin === location.origin && u.pathname.replace(/\/$/, '') === cartPath && !u.search;
      } catch {}
    }
    isCart ||= target.getAttribute('aria-controls') === 'cart-drawer';
    isCart ||= !!target.closest('cart-drawer-component') && /\/open/.test(target.getAttribute('on:click') || '');
    if (isCart) { e.preventDefault(); e.stopImmediatePropagation(); open(); }
  }, true);
  function mutationType(input, method) {
    try {
      const u = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      if (u.origin !== location.origin || String(method).toUpperCase() !== 'POST') return '';
      return u.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/)?.[1] || '';
    } catch { return ''; }
  }
  function changed(type) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (busy) { changed(type); return; }
      if (type === 'add') open();
      else if (drawer.open) refresh().catch(() => status(strings.error));
    }, 120);
  }
  window.fetch = function(input, options) {
    const type = mutationType(input, options?.method || input?.method || 'GET');
    const result = nativeFetch(input, options);
    if (type) result.then(r => { if (r.ok) changed(type); }, () => {});
    return result;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    const type = mutationType(url, method);
    if (type) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) changed(type); }, { once: true });
    return xhrOpen.call(this, method, url, ...args);
  };
  window.addEventListener('pageshow', () => { if (drawer.open) refresh().catch(() => status(strings.error)); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && drawer.open) refresh().catch(() => status(strings.error));
  });
  document.addEventListener('ps:cart:open', open);
  document.addEventListener('ps:cart:refresh', () => changed('update'));
  window.PSCart = { open, close, refresh };
  sanitiseLinks();
  updateShipping();
})();
